mutation packagesCrud($originId: ID!, $scenarioId: ID!, $input: PackageCrudInput!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    packagesCrud(input: $input) {
      skippedValidations
      commited
      payload {
        updates {
          replicatedPackages {
            id
            code
            vacancies
            index
            isVisible
            isPublished
            __typename
          }
          package {
            id
            code
            vacancies
            index
            isVisible
            isPublished
            isReplicated
            __typename
          }
          validationErrors {
            ... on InvalidLinksCourse {
              __typename
              reason
            }
            ... on InvalidLinksPackage {
              __typename
              reason
            }
            ... on PackagePublishingDisabled {
              __typename
              allowed
              reason
            }
            __typename
          }
          __typename
        }
        creates {
          package {
            id
            code
            vacancies
            index
            population {
              id
              code
              level
              curriculum
              campus {
                id
                code
              }
              modality {
                id
                code
              }
              shift {
                id
                code
              }
              program {
                id
                code
              }
              term {
                name
                code
                id
              }
              courses {
                id
                curriculum {
                  id
                  code
                  program {
                    id
                    code
                    campus {
                      id
                      code
                    }
                    modality {
                      id
                      code
                    }
                    shift {
                      id
                      code
                    }
                  }
                }
              }
            }
            __typename
          }
          link {
            id
            code
            vacancies
            groups {
              id
              type
            }
            packages {
              id
              code
              index
              vacancies
              complete
              hasPackageRules
              type
            }
            bundle {
              id
              code
              label
              name
            }
            course {
              id
              code
              label
              name
              level
              courseComponents {
                id
                component {
                  id
                  code
                  name
                }
              }
              curriculum {
                id
                code
                name
                program {
                  id
                  code
                  name
                  modality {
                    id
                    code
                  }
                  campus {
                    id
                    code
                  }
                  department {
                    id
                    code
                  }
                  shift {
                    id
                    code
                  }
                }
              }
            }
            totalBlocks
          }
          validationErrors {
            ... on InvalidLinksCourse {
              __typename
              reason
            }
            ... on InvalidLinksPackage {
              __typename
              reason
            }
            ... on ClashesBetweenPackages {
              __typename
              allowed
              reason
            }
          }
        }
        deletes {
          package {
            id
            code
            vacancies
            index
            population {
              id
              code
              level
              curriculum
              campus {
                id
                code
              }
              modality {
                id
                code
              }
              shift {
                id
                code
              }
              program {
                id
                code
              }
              courses {
                id
                curriculum {
                  id
                  code
                  program {
                    id
                    code
                    campus {
                      id
                      code
                    }
                    modality {
                      id
                      code
                    }
                    shift {
                      id
                      code
                    }
                  }
                }
              }
            }
            __typename
          }
          link {
            id
            code
            vacancies
            groups {
              id
              type
            }
            packages {
              id
              code
              index
              vacancies
              complete
              hasPackageRules
              type
              population {
                id
                code
                size
                level
                packageCount
                campus {
                  id
                  code
                  name
                }
                modality {
                  id
                  code
                  name
                }
                shift {
                  id
                  code
                  name
                }
                program {
                  id
                  code
                  name
                  label
                }
                curriculum
              }
            }
            bundle {
              id
              code
              label
              name
            }
            course {
              id
              code
              label
              name
              level
              courseComponents {
                id
                component {
                  id
                  code
                  name
                }
              }
              curriculum {
                id
                code
                name
                program {
                  id
                  code
                  name
                  modality {
                    id
                    code
                  }
                  campus {
                    id
                    code
                  }
                  department {
                    id
                    code
                  }
                  shift {
                    id
                    code
                  }
                }
              }
            }
            totalBlocks
          }
          validationErrors {
            ... on CanDeletePackages {
              __typename
              reason
            }
            ... on InvalidLinksCourse {
              __typename
              reason
            }
            ... on InvalidLinksPackage {
              __typename
              reason
            }
            ... on ClashesBetweenPackages {
              __typename
              allowed
              reason
            }
          }
        }
      }
      userCanSkipValidations
    }
  }
}
